// Стабильные коды и подписи, которые нужны фронту до загрузки данных или для служебных
// фильтров. Основной источник подписей — API (/analytics/calls/filter-options).

export const INTENT_LABELS = {
  new_lead: 'Новая заявка',
  confirmation: 'Подтверждение',
  followup_or_reactivation: 'Дожим/реактивация',
  sale_or_order: 'Покупка',
  support_or_question: 'Вопрос/поддержка',
  no_answer_or_technical: 'Недозвон/техника',
  request_info: 'Запрос информации',
  confirm_attendance: 'Подтверждение участия',
  enroll_training: 'Запись на обучение',
  buy_products: 'Покупка продуктов',
  confirm_order: 'Подтверждение покупки',
  ask_price: 'Вопрос о цене',
  choose_program: 'Выбор программы',
  discuss_individual_training: 'Индивидуальное обучение',
  complaint: 'Жалоба',
  existing_booking_or_order: 'Существующая заявка',
  followup: 'Повторный контакт',
  sales_outbound: 'Продажный обзвон',
  information_request: 'Информационный запрос',
  new_request: 'Новый запрос',
  problem_resolution: 'Решение проблемы',
  website_order: 'Покупка с сайта',
  test_ride: 'Тест-райд',
  preorder: 'Предварительная покупка',
  rental_or_booking: 'Аренда/бронь',
  service_or_repair: 'Сервис/ремонт',
  usage_consultation: 'Консультация по эксплуатации',
  logistics_or_delivery: 'Логистика/доставка',
  access_or_pass: 'Пропуск/доступ',
  payment_or_documents: 'Оплата/документы',
  internal_or_partner: 'Внутренний/партнерский звонок',
  other: 'Другое'
};

export const INTENT_COLORS = {
  new_lead: '#2563eb',
  confirmation: '#16a34a',
  followup_or_reactivation: '#f59e0b',
  sale_or_order: '#0ea5e9',
  support_or_question: '#14b8a6',
  no_answer_or_technical: '#64748b',
  request_info: '#2563eb',
  confirm_attendance: '#16a34a',
  enroll_training: '#22c55e',
  buy_products: '#0ea5e9',
  confirm_order: '#0891b2',
  ask_price: '#f59e0b',
  choose_program: '#7c3aed',
  discuss_individual_training: '#a855f7',
  complaint: '#ef4444',
  existing_booking_or_order: '#0891b2',
  followup: '#f59e0b',
  sales_outbound: '#0f766e',
  information_request: '#2563eb',
  new_request: '#16a34a',
  problem_resolution: '#ef4444',
  website_order: '#2563eb',
  test_ride: '#7c3aed',
  preorder: '#0891b2',
  rental_or_booking: '#0ea5e9',
  service_or_repair: '#ef4444',
  usage_consultation: '#14b8a6',
  logistics_or_delivery: '#f59e0b',
  access_or_pass: '#64748b',
  payment_or_documents: '#16a34a',
  internal_or_partner: '#475569',
  other: '#7c3aed',
  __unknown: '#94a3b8'
};

// Список ВЫБОРА фильтра «Направление» — то, что пользователь может выбрать сегодня.
// Это не словарь подписей: исторические коды (`training_center`, `inbound`, `internal`, …)
// продолжают встречаться в уже записанных данных и подписываются `formatCallDirection`
// из `utils/labels.js`. Раньше это был один объект, и укоротить список выбора значило
// разом перестать подписывать историю.
//
// Тенант-развилки здесь нет намеренно: короткий набор отдавался только при
// REACT_APP_TENANT_ID = 'electrobike', а всем остальным (в том числе при незаданной
// переменной) доставались демо-коды МезоРеал, по которым выдача всегда пустая.
export const CALL_TYPE_OPTIONS = [
  { code: 'all', label: 'Все звонки' },
  { code: 'incoming', label: 'Входящие' },
  { code: 'outgoing', label: 'Исходящие' }
];

export const SERVICE_AREA_LABELS = {
  contour_plastic: 'Контурная пластика',
  mesotherapy: 'Мезотерапия',
  biorevitalization: 'Биоревитализация',
  peels: 'Пилинги',
  botox: 'Ботокс',
  hardware: 'Аппаратные методики',
  documents: 'Документы/медобразование',
  full_face: 'Full Face',
  orbital_zone: 'Орбитальная зона',
  schedule: 'Расписание',
  price_discount: 'Цена/скидка',
  product_advice: 'Консультация по продуктам',
  order: 'Покупка',
  website_order: 'Покупка с сайта',
  test_ride: 'Тест-райд',
  preorder: 'Предварительная покупка',
  rental_or_booking: 'Аренда/бронь',
  service_or_repair: 'Сервис/ремонт',
  usage_consultation: 'Консультация по эксплуатации',
  logistics_or_delivery: 'Логистика/доставка',
  access_or_pass: 'Пропуск/доступ',
  payment_or_documents: 'Оплата/документы',
  internal_or_partner: 'Внутренний/партнерский звонок',
  no_answer_or_technical: 'Недозвон/техника',
  other: 'Другое',
  unknown: 'Не определено',
  not_applicable: 'Не применимо'
};

export const QUALITY_FORMS = [
  { code: 'sales_full_checklist', label: 'Продажный чек-лист' },
  { code: 'short_limited', label: 'Короткая консультация' },
  { code: 'logistics_limited', label: 'Логистика' },
  { code: 'technical_service_checklist', label: 'ТО/техподдержка' }
];

export const QUALITY_FORM_LABELS = QUALITY_FORMS.reduce((acc, form) => {
  acc[form.code] = form.label;
  return acc;
}, {});

export const FUNNEL_STAGE_LABELS = {
  applicable: 'Целевое действие применимо',
  attempt: 'Была попытка довести до результата',
  success: 'Целевое действие достигнуто',
  refusal: 'Отказ или зависло'
};

export const CALLS_METRIC_OPTIONS = [
  { code: 'calls', label: 'Все звонки' },
  { code: 'applicable', label: 'Применимые' },
  { code: 'attempts', label: 'Попытки результата' },
  { code: 'bookings', label: 'Достигнуто' }
];

// Код возражения «Дорого» — по брифу выделяется отдельным акцентным цветом.
export const EXPENSIVE_OBJECTION_CODE = 'expensive';
